import { render, staticRenderFns } from "./ValidateAnnouncementME.vue?vue&type=template&id=4f327ab4&scoped=true"
import script from "./ValidateAnnouncementME.vue?vue&type=script&lang=js"
export * from "./ValidateAnnouncementME.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f327ab4",
  null
  
)

export default component.exports